import React from "react";
import Sectiontitle from "../components/Sectiontitle";
import Layout from "../components/Layout";
import Service from "../components/Service";
import { Fade } from 'react-awesome-reveal';
import { useLanguage } from '../context/LanguageContext';

function About() {
  const { d } = useLanguage();

  return (
    <Layout>
      <div className="mi-about-area mi-section mi-padding-top">
        <div className="container">
          <Sectiontitle title={d.titles.about} />
          <Fade triggerOnce delay={100}>
            <div className="row">
              <div className="col-lg-6">
                <div className="mi-about-image">
                  <img src={d.information.aboutImage} alt="about" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mi-about-content">
                  <h3>
                    {d.information.aboutRows.i} <span className="color-theme">{d.information.name}</span>
                  </h3>
                  <p>
                    {d.information.aboutSumary}
                  </p>
                  <ul>
                    <li>
                      <b>{d.information.aboutRows.nam}</b> {d.information.name}
                    </li>
                    <li>
                      <b>{d.information.aboutRows.tit}</b> {d.information.title}
                    </li>
                    <li>
                      <b>{d.information.aboutRows.age}</b> {d.information.age} {d.information.aboutRows.ani}
                    </li>
                    <li>
                      <b>{d.information.aboutRows.nat}</b> {d.information.nationality}
                    </li>
                    <li>
                      <b>{d.information.aboutRows.lan}</b> {d.information.language}
                    </li>
                    <li>
                      <b>{d.information.aboutRows.ema}</b> {d.information.email}
                    </li>
                    <li>
                      <b>{d.information.aboutRows.add}</b> {d.information.address}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
      <div className="mi-service-area mi-section mi-padding-top mi-padding-bottom">
        <div className="container">
          <Sectiontitle title={d.titles.services} />
          <div className="mi-service-wrapper">
            <div className="row mt-30-reverse">
              {d.services.map((service) => (
                <div
                  className="col-lg-4 col-md-6 col-12 mt-30"
                  key={service.title} >
                  <Service content={service} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default About;
